<template>
    <div @click="selectServer" class="server-widget server-widget-hoverable-border" :class="{ 'server-widget-selected-border': selectedServerId == server.id }">
        <div class="server-name">{{ server.name }}</div>
        <div class="server-host">
            <font-awesome-icon icon="server"/>&nbsp;&nbsp;{{ server.host }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['server', 'selectedServerId'],

    methods: {
        selectServer() {
            Event.$emit('serverSelected', this.server);
        },
    },
}
</script>